import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import DispensingDetailTable from './dispensingDetailTable/DispensingDetailTable';

const ConfigDispensing = () => {
  const history = useHistory();
  const user = useSelector(store => store.loginManager.status);
  const [ modules, setModules ] = useState(null);

  useEffect(() => {
    customAxiosGetFunction(history, '/api/module/getDataByAuth/dispensing/', { params: { authIdx: user.authIdx }})
      .then(response => {
        setModules(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [])

  if (!modules) {
    return null;
  }

  return (
    <section>
      <DispensingDetailTable areas={[]} modules={modules} />
    </section>
  )
}

export default ConfigDispensing;